import { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      console.log('Processing session, hash:', hash);
      console.log('Session ID:', sessionId);

      if (!sessionId) {
        console.error('No session_id found in URL');
        setStatus('error');
        setError('No session ID found');
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
        return;
      }

      try {
        console.log('Calling backend with session_id:', sessionId);
        const response = await axios.post(
          `${BACKEND_URL}/api/auth/session`,
          { session_id: sessionId },
          {
            headers: { 'Content-Type': 'application/json' }
          }
        );

        console.log('Auth response:', response.data);
        const { session_token, user } = response.data;
        
        if (session_token) {
          localStorage.setItem('session_token', session_token);
          console.log('Session token stored, redirecting');
          setStatus('success');

          // Return the user to wherever they started (e.g. a beneficiary invite), else dashboard.
          const dest = localStorage.getItem('post_auth_redirect') || '/dashboard';
          localStorage.removeItem('post_auth_redirect');
          setTimeout(() => {
            window.location.href = dest;
          }, 500);
        } else {
          console.error('No session_token in response');
          setStatus('error');
          setError('Authentication failed');
          setTimeout(() => {
            window.location.href = '/login';
          }, 2000);
        }
      } catch (error) {
        console.error('Session processing failed:', error);
        console.error('Error details:', error.response?.data);
        setStatus('error');
        setError(error.response?.data?.detail || 'Authentication failed');
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      }
    };

    processSession();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#EBF0F5] via-[#F7F1E8] to-[#EBF0F5]">
      <div className="text-center">
        {status === 'processing' && (
          <>
            <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-[#2B4C7E] border-r-transparent mb-4"></div>
            <p className="text-[#2B4C7E] font-medium">Signing you in...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <p className="text-green-600 font-medium">Success! Redirecting...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </div>
            <p className="text-red-600 font-medium">{error || 'Authentication failed'}</p>
            <p className="text-gray-500 text-sm mt-2">Redirecting to login...</p>
          </>
        )}
      </div>
    </div>
  );
}